<template>
  <div><policies product="BGYS"></policies></div>
</template>

<script>
import policies from "./policies.vue";
export default {
  components: { policies },
};
</script>
